import { createFeatureSelector, createSelector } from "@ngrx/store";
import { RootState } from "src/app/root-store/root-state";
import { KwikspaceStoreState } from "../state";

export const featureKey = "kwikspaceApp";

const getKwikspaceAppState = createFeatureSelector<RootState, KwikspaceStoreState>(
  featureKey
);

export const getProductList = createSelector(
  getKwikspaceAppState,
  (state) => state.product.products
);

export const getProductListLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.product.productsLoading
);

export const getProductListError = createSelector(
  getKwikspaceAppState,
  (state) => state.product.productsError
);

export const getPagedProductList = createSelector(
  getKwikspaceAppState,
  (state) => state.product.productList
);

export const getPagedProductListLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.product.productListLoading
);

export const getPagedProductListError = createSelector(
  getKwikspaceAppState,
  (state) => state.product.productListError
);

export const getProductConfiguration = createSelector(
  getKwikspaceAppState,
  (state) => state.product.productConfigurations
);

export const getProductConfigurationLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.product.productConfigurationsLoading
);

export const getProductConfigurationError = createSelector(
  getKwikspaceAppState,
  (state) => state.product.productConfigurationsError
);

export const getCreatedProductConfiguration = createSelector(
  getKwikspaceAppState,
  (state) => state.product.createdProductConfigurations
);

export const getCreatedProductConfigurationLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.product.createProductConfigurationLoading
);

export const getCreatedProductConfigurationError = createSelector(
  getKwikspaceAppState,
  (state) => state.product.createProductConfigurationError
);

export const getCreatedProductConfigurationSuccess = createSelector(
  getKwikspaceAppState,
  (state) => state.product.createProductConfigurationSuccess
);

export const updateProductConfigurationLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.product.updateProductConfigurationLoading
);

export const updateProductConfigurationError = createSelector(
  getKwikspaceAppState,
  (state) => state.product.updateProductConfigurationError
);

export const updateProductConfigurationSuccess = createSelector(
  getKwikspaceAppState,
  (state) => state.product.updateProductConfigurationSuccess
);
